import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniatouristbusonrent() {



    const cardData =
    {
        keyword: 'Urbania Tourist Bus On Rent in Pune',
        heading: 'Urbania on rent in pune: Urbania Tourist Bus On Rent in Pune',
        headingDescription: 'Urbania On Rent in Pune offers premium and dependable Urbania Tourist Bus On Rent in Pune services for families, corporate groups, tourists, and event travelers seeking comfortable and spacious group transportation. Our well-maintained Force Urbania tourist bus fleet provides generous seating, air-conditioned comfort, luggage space, and smooth performance, making it ideal for local sightseeing tours, airport transfers, weekend getaways, weddings, corporate outings, and outstation journeys from Pune. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the trusted choice for Urbania tourist bus hire in Pune.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is Pune’s most iconic historical landmark, built in 1732 as the seat of the Peshwa rulers of the Maratha Empire. The massive fortification features grand gates like Delhi Darwaza, sturdy stone walls, and remnants of royal courtyards. Though a major fire destroyed much of the original structure, the ruins still narrate tales of Maratha valor and administration. The evening light-and-sound show vividly brings Pune’s glorious past to life, making it a must-visit heritage attraction."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a significant monument connected to India’s freedom struggle. Built in 1892, it served as a prison for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during the Quit India Movement. Today, it functions as a memorial and museum displaying photographs, personal belongings, and letters of Gandhi. Surrounded by expansive lawns and elegant Italian-style arches, the palace offers a peaceful yet historically powerful experience."
  },
  {
    "title": "Shreemant Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is one of Maharashtra’s most famous Ganesha temples and the spiritual heart of Pune. The beautifully adorned idol is decorated with gold ornaments and attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the center of grand celebrations, processions, and cultural events. The trust is also well-known for its social and charitable initiatives."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a historic hill fortress located about 30 km from Pune, renowned for the legendary battle fought by Tanaji Malusare. Perched atop the Sahyadri ranges, the fort offers panoramic views, ancient bastions, and memorials. It is a popular destination for trekking, history exploration, and enjoying local Maharashtrian food like pithla-bhakri served by villagers near the summit."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. Despite being located in a busy part of the city, the temple maintains a calm and meditative atmosphere. The monolithic pillars, circular Nandi mandap, and ancient carvings reflect early Indian craftsmanship and architectural brilliance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a cultural treasure house displaying over 20,000 artifacts collected by Dr. Dinkar Kelkar. The museum showcases traditional Indian art, musical instruments, lamps, doors, sculptures, and everyday household items from across India. The recreated Mastani Mahal is one of its highlights, offering a glimpse into royal Maratha lifestyle and heritage."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of the oldest heritage sites in Pune, offering breathtaking views of the city from its summit. After climbing 103 steps, visitors reach the Parvati Temple complex dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. The hilltop also houses smaller shrines and a museum, making it a blend of spirituality, history, and scenic beauty."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a world-renowned center for meditation, mindfulness, and spiritual wellness. Surrounded by lush greenery, it attracts visitors from across the globe seeking peace, relaxation, and self-discovery. The serene environment, meditation programs, and wellness therapies make it a unique spiritual retreat in Pune."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by the famous Korakuen Garden of Japan, is Pune’s largest landscaped garden. It features flowing water streams, stone bridges, manicured lawns, and seasonal flowers. The garden is ideal for peaceful walks, family outings, and photography, offering a refreshing escape from city life."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular picnic and leisure destination near Pune. The vast water reservoir, surrounding hills, and cool breezes create a scenic environment, especially during the monsoon season. Visitors enjoy evening strolls, local street food, and beautiful sunset views, making it a favorite weekend getaway for Pune residents."
  }
],




 "services": [
{
"name": "Urbania Tourist Bus on Rent in Pune",
"description": "Urbania Tourist Bus on Rent in Pune offers reliable and well-maintained Urbania buses for local and outstation sightseeing tours. The service is ideal for tourists, families, and groups looking for comfortable seating, ample luggage space, and a smooth travel experience across Pune and nearby destinations with professional drivers."
},
{
"name": "Tourist Urbania Bus Hire Pune",
"description": "Tourist Urbania Bus Hire Pune provides flexible bus hire solutions for city tours, weekend trips, and long-distance travel. With clean interiors, comfortable seating, and trained chauffeurs, this service ensures safe, punctual, and enjoyable journeys for all types of travelers."
},
{
"name": "Urbania Rental Service for Tour Pune",
"description": "Urbania Rental Service for Tour Pune delivers customized rental packages for sightseeing, holiday tours, and multi-day travel plans. Designed to meet diverse travel needs, the service focuses on comfort, safety, and hassle-free transportation throughout the tour."
},
{
"name": "Urbania AC Tourist Bus Pune",
"description": "Urbania AC Tourist Bus Pune offers fully air-conditioned buses that provide a relaxed and climate-controlled environment for long journeys. Perfect for sightseeing and outstation tours, these buses ensure comfort even during extended travel hours."
},
{
"name": "Corporate Tourist Urbania Pune",
"description": "Corporate Tourist Urbania Pune offers organized and professional transport solutions for corporate outings, team tours, and business travel. With punctual pickups, comfortable interiors, and experienced drivers, it ensures smooth and efficient group travel."
},
{
"name": "Family Tour Urbania Pune",
"description": "Family Tour Urbania Pune is specially designed for family vacations and group outings, providing spacious seating, safety-focused travel, and a comfortable environment suitable for all age groups."
},
{
"name": "Luxury Tourist Urbania Pune",
"description": "Luxury Tourist Urbania Pune delivers premium travel experiences with modern interiors, plush seating, and superior comfort. Ideal for luxury tours and VIP travel, this service combines style with reliable performance."
},
{
"name": "Affordable Tourist Urbania Hire Pune",
"description": "Affordable Tourist Urbania Hire Pune provides cost-effective bus rental options without compromising on comfort or safety. It is suitable for budget-conscious travelers seeking dependable tourist transport services."
},
{
"name": "Chauffeur Driven Tourist Urbania Pune",
"description": "Chauffeur Driven Tourist Urbania Pune ensures stress-free travel with skilled, verified, and route-experienced drivers. This service is ideal for tourists who want a relaxed journey without worrying about navigation or driving."
},
{
"name": "Urbania for Outstation Tours Pune",
"description": "Urbania for Outstation Tours Pune offers comfortable and reliable buses for long-distance travel from Pune to popular tourist destinations. Designed for extended journeys, the buses feature spacious seating and smooth ride quality."
},
{
"name": "Best Tourist Urbania Rental Pune",
"description": "Best Tourist Urbania Rental Pune provides top-rated Urbania buses known for cleanliness, comfort, and timely service. It is a preferred choice for tourists seeking dependable and high-quality travel solutions."
},
{
"name": "Group Travel Tourist Urbania Pune",
"description": "Group Travel Tourist Urbania Pune offers spacious and well-organized bus services for large groups, ensuring everyone travels together comfortably and reaches destinations on time."
},
{
"name": "Urbania for Pilgrimage Tours Pune",
"description": "Urbania for Pilgrimage Tours Pune specializes in religious and spiritual travel, offering comfortable buses, disciplined chauffeurs, and well-planned routes for peaceful pilgrimage journeys."
},
{
"name": "Trusted Tourist Urbania Service Pune",
"description": "Trusted Tourist Urbania Service Pune is known for dependable operations, customer-focused service, and safe travel standards, making it a reliable choice for tourist bus rentals in Pune."
},
{
"name": "Comfortable Tourist Urbania Pune",
"description": "Comfortable Tourist Urbania Pune focuses on delivering a smooth and relaxed travel experience with ergonomic seating, clean interiors, and thoughtful amenities for enjoyable tourist journeys."
}
],
"tableData": [
["Urbania Tourist Bus on Rent in Pune", "Tourist Urbania Bus Hire Pune"],
["Urbania Rental Service for Tour Pune", "Urbania AC Tourist Bus Pune"],
["Corporate Tourist Urbania Pune", "Family Tour Urbania Pune"],
["Luxury Tourist Urbania Pune", "Affordable Tourist Urbania Hire Pune"],
["Chauffeur Driven Tourist Urbania Pune", "Urbania for Outstation Tours Pune"],
["Best Tourist Urbania Rental Pune", "Group Travel Tourist Urbania Pune"],
["Urbania for Pilgrimage Tours Pune", "Trusted Tourist Urbania Service Pune"],
["Comfortable Tourist Urbania Pune", ""]
],



whychoose : [
    {
        "WhyChooseheading": "Urbania Tourist Bus On Rent in Pune for Comfortable Travel",
        "WhyChoosedescription": "Urbania Tourist Bus On Rent in Pune is ideal for city tours, outstation trips, group travel, family outings, corporate tours, and sightseeing journeys, ensuring a comfortable and smooth ride."
    },
    {
        "WhyChooseheading": "Spacious and Modern Urbania Tourist Buses",
        "WhyChoosedescription": "Our Urbania tourist buses in Pune are equipped with air-conditioning, ample legroom, comfortable reclining seats, and sufficient luggage space for a pleasant travel experience."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "All drivers are trained, licensed, and experienced in handling local and outstation tourist routes from Pune, ensuring safe and stress-free travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Urbania Tourist Bus On Rent in Pune offers competitive pricing with no hidden charges, making group and tourist travel cost-effective."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "We provide round-the-clock booking assistance and dedicated customer support for inquiries, reservations, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Travel Packages",
        "WhyChoosedescription": "Available for local sightseeing, outstation trips, multi-day tours, corporate outings, and customized travel plans as per your schedule."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania tourist buses are regularly cleaned, sanitized, and maintained to ensure passenger comfort and safety."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Our Urbania Tourist Bus On Rent in Pune guarantees on-time pickups, reliable service, and a smooth overall travel experience."
    }
]
}
const faqData = [
    {
        question: 'Can Urbania Tourist Bus On Rent in Pune be booked for outstation travel?',
        answer: 'Yes, it can be booked for outstation trips, sightseeing tours, family vacations, corporate travel, and group journeys.'
    },
    {
        question: 'How can I book Urbania Tourist Bus On Rent in Pune?',
        answer: 'Bookings can be made via phone, WhatsApp, or online for quick and convenient reservations.'
    },
    {
        question: 'Why choose Urbania Tourist Bus On Rent in Pune?',
        answer: 'This service offers spacious seating, professional drivers, clean vehicles, flexible travel packages, and transparent pricing.'
    },
    {
        question: 'Are the drivers experienced for tourist routes?',
        answer: 'Yes, all drivers are experienced and familiar with Pune city routes and popular tourist destinations.'
    },
    {
        question: 'Can pickup and drop locations be customized?',
        answer: 'Absolutely. Flexible pickup and drop-off locations are available across Pune and nearby areas.'
    },
    {
        question: 'Is Urbania Tourist Bus On Rent in Pune available 24/7?',
        answer: 'Yes, booking and customer support services are available 24/7.'
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all buses are thoroughly cleaned, sanitized, and well-maintained for passenger safety.'
    },
    {
        question: 'What payment options are accepted?',
        answer: 'Payments can be made via UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing.'
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey.'
    },
    {
        question: 'Is this service suitable for families and corporate groups?',
        answer: 'Yes, Urbania Tourist Bus On Rent in Pune is perfect for families, corporate groups, tourists, and large travel groups.'
    }
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Amit Kulkarni',
        feedback: 'We hired an Urbania tourist bus in Pune for a family trip. The bus was spacious, clean, and the journey was very comfortable.',
        rating: 5
    },
    {
        id: 2,
        name: 'Ms. Priya Shah',
        feedback: 'Excellent service and professional driver. Urbania Tourist Bus On Rent in Pune made our group tour smooth and enjoyable.',
        rating: 5
    }
];






































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Tourist Bus On Rent in Pune",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-tourist-bus-pune.jpg",
  "description": "Urbania Tourist Bus on Rent in Pune offers AC Urbania buses for one-way or round-trip travel, corporate trips, family tours, pilgrimage journeys, and group travel. Chauffeur-driven Urbania buses ensure safe, comfortable, and convenient transportation for sightseeing and tours in and around Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-tourist-bus-on-rent-pune"
  }
};






    return (
        <div>

<Helmet>
  <title>
    Call:+91 9209423113 | Urbania Tourist Bus On Rent in Pune | AC Urbania Bus for Tours & Travel 
  </title>

  <meta
    name="description"
    content="Book Urbania Tourist Bus on Rent in Pune for one-way or round-trip travel, corporate trips, family tours, pilgrimage journeys, and group travel. AC Urbania buses with chauffeur-driven service provide safe, comfortable, and convenient transportation for sightseeing and tours in Pune."
  />

  <meta
    name="keywords"
    content="Urbania Tourist Bus on Rent in Pune, Tourist Urbania Bus Hire Pune, Urbania Rental Service for Tour Pune, Urbania AC Tourist Bus Pune, Corporate Tourist Urbania Pune, Family Tour Urbania Pune, Luxury Tourist Urbania Pune, Affordable Tourist Urbania Hire Pune, Chauffeur Driven Tourist Urbania Pune, Urbania for Outstation Tours Pune, Best Tourist Urbania Rental Pune, Group Travel Tourist Urbania Pune, Urbania for Pilgrimage Tours Pune, Trusted Tourist Urbania Service Pune, Comfortable Tourist Urbania Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/106.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniatouristbusonrent;